import { render } from "./PitStatement.vue?vue&type=template&id=08e6d213"
import script from "./PitStatement.vue?vue&type=script&lang=js"
export * from "./PitStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__